module.exports = __webpack_public_path__ + "img/a7.e5251226.png";